<template>
  <CustomPage
    :title="$route.query.suitName + '(' + suitGoodsList.length + '件)'"
    color="black"
    bgcolor="white"
  >
    <div slot="content">
      <div class="pb-16">
        <div
          v-for="(item, index) in suitGoodsList"
          :key="index"
          class="flex p-3"
        >
          <div style="width: 116px; height: 116px" class="flex-shrink-0 mr-3">
            <img
              class="w-full h-full rounded-lg"
              :src="item.goodsInfoImg"
              alt=""
            />
          </div>
          <div class="flex flex-col flex-grow justify-between">
            <div class="text-sm">
              {{ item.goodsName }}
            </div>
            <div>
              <div
                v-if="item.specStr !== ''"
                class="text-xs inline-block bg-f8 p-1"
                @click="showSku(item)"
              >
                {{ item.specStr }}
              </div>
            </div>
            <div class="flex justify-between items-center">
              <div class="flex items-center">
                <div class="font-bold mr-1">
                  <span class="text-sm">¥</span
                  ><span class="text-2xl">{{ item.actPrice }}</span>
                </div>
                <div class="text-xxs text-white bg-red rounded py-1 px-2">
                  立减{{ item.reducePrice }}元
                </div>
              </div>
              <div
                class="text-xxs"
                style="color: #aeaeae"
                @click="readDetail(item.partGoodsId, item.actId)"
              >
                查看详情
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="
          fixed
          bottom-0
          left-0
          right-0
          bg-white
          flex
          justify-between
          p-3
          items-center
        "
      >
        <div>
          <div style="color: #333333" class="text-xxs">
            活动价总价：¥{{ actPriceTotal }}
          </div>
          <div>
            <span style="color: #333333" class="text-sm">套装优惠价：</span
            ><span class="text-red font-bold">¥{{ suitPriceTotal }}</span>
          </div>
        </div>
        <Button
          round
          :type="warmingUp ? 'default' : 'danger'"
          class="px-10 h-10"
          @click="buy"
          >{{ warmingUp ? "即将开始" : "立即购买" }}</Button
        >
      </div>
      <Sku
        v-model="show"
        :sku="sku"
        :goods="goods"
        :goods-id="partGoodsId"
        :quota="quota"
        :quota-used="quotaUsed"
        @sku-selected="skuSelected"
        :hide-stock="sku.hide_stock"
        @add-cart="onAddCartClicked"
      >
        <template #sku-stepper>
          <div></div>
        </template>
        <template #sku-actions="props">
          <div class="van-sku-actions">
            <Button
              v-if="cartBtn !== 'buy'"
              square
              size="large"
              type="warning"
              @click="props.skuEventBus.$emit('sku:addCart')"
              style="
                background: white;
                color: #e82035;
                border: #e82035 1px solid;
              "
            >
              确定
            </Button>
          </div>
        </template></Sku
      >
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import { Button, Sku, Toast } from "vant";
import { getSuitGoods } from "./webApi";
export default {
  components: { CustomPage, Button, Sku },
  created() {
    getSuitGoods(this.$route.query.suitId).then(({ data }) => {
      this.suitGoodsList = data;
      this.warmingUp = data[0].state === "WARMING_UP";
      this.suitGoodsList.forEach((item) => {
        if (item.distMarkup) {
          item.actPrice += item.distMarkup;
          item.goodsInfoList.forEach((item2) => {
            item2.actPrice += item.distMarkup;
          });
        }
        if (item.goodsSpecs.length) {
          item.specArr = item.goodsSpecs.map((item2) => item2.specName);
          item.specStr = "请选择规格 >";
        } else {
          item.specStr = "";
          item.selectedSku = item.goodsInfoList[0].partGoodsInfoId;
        }
      });
    });
  },
  data() {
    return {
      suitGoodsList: [],
      warmingUp: false,
      // =============================================sku部分开始=============================================
      cartBtn: "both",
      partGoodsId: "",
      quota: 0, //限购数，0 表示不限购
      quotaUsed: 0, //已经购买过的数量
      show: false,
      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。

        tree: [],

        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [],
        price: "1.00", // 默认价格（单位元）
        stock_num: 227, // 商品总库存
        collection_id: 2261, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: false, // 是否无规格商品

        hide_stock: false, // 是否隐藏剩余库存
      },
      goods: {
        // 默认商品 sku 缩略图
        picture: "",
      },

      // =============================================sku部分结束=============================================}
    };
  },
  methods: {
    showSku(item) {
      console.log(item);
      this.computeSku(item);
      this.show = true;
    },
    computeSku(item) {
      console.log("item", item);
      let data = item;
      this.goodsDetail = data;
      this.goods.picture = data.goodsInfoImg;
      this.partGoodsId = data.partGoodsId;
      this.sku.price = data.actPrice;
      this.sku.stock_num = data.stock;
      let tree = [];
      data.goodsSpecs.map((item) => {
        let tempV = [];
        data.goodsSpecDetails.map((item2) => {
          if (item2.specId === item.specId) {
            tempV.push({
              id: item2.specDetailId,
              name: item2.detailName,
            });
          }
        });
        tree.push({
          k: item.specName,
          k_id: item.specId,
          v: tempV,
          k_s: item.specName,
        });
      });
      console.log("tree!", tree);

      let list = [];
      data.goodsInfoList.map((item) => {
        let temp = {
          id: item.partGoodsInfoId,
          price: item.actPrice * 100,
          stock_num: item.stock,
        };
        item.goodsInfoSpecDetails.map((item2) => {
          temp[item2.specName] = item2.specDetailId;
        });
        list.push(temp);
      });
      console.log("list", list);
      this.sku.tree = tree;
      this.sku.list = list;
    },
    skuSelected(skuValue) {
      console.log("skuValue", skuValue);
      if (skuValue.selectedSkuComb) {
        this.suitGoodsList.forEach((item) => {
          if (this.partGoodsId === item.partGoodsId) {
            item.goodsInfoList.map((sku) => {
              if (skuValue.selectedSkuComb.id === sku.partGoodsInfoId) {
                this.goods.picture = sku.goodsInfoImg;
                // item.goodsInfoImg = sku.goodsInfoImg;
              }
              return;
            });
            return;
          }
        });
      } else {
        this.suitGoodsList.map((item) => {
          if (this.partGoodsId === item.partGoodsId) {
            this.goods.picture = item.goodsInfoImg;
            return;
          }
        });
      }
    },
    onAddCartClicked(e) {
      console.log(e);
      this.suitGoodsList.forEach((item) => {
        if (e.goodsId === item.partGoodsId) {
          item.actPrice = e.selectedSkuComb.price / 100;
          item.selectedSku = e.selectedSkuComb.id;
          item.selectedSpec = [];
          item.specArr.map((specName) => {
            item.goodsSpecDetails.map((i) => {
              if (e.selectedSkuComb[specName] === i.specDetailId) {
                item.selectedSpec.push(i.detailName);
                return;
              }
            });
          });
          item.specStr = item.selectedSpec.join("; ");
          return;
        }
      });
      this.show = false;
      console.log(this.suitGoodsList);
    },
    buy() {
      if (this.warmingUp) return;
      let skus = [];
      let flag = true;
      this.suitGoodsList.map((item) => {
        if (!item.selectedSku) {
          flag = false;
          return;
        }
        skus.push(item.selectedSku);
      });
      if (flag) {
        console.log(skus);
        console.log(this.$route.query.suitId);
        let subData = {
          orderGroups: [
            {
              actId: this.suitGoodsList[0].actId,
              actName: this.$route.query.actName,
              orders: [],
            },
          ],
          suite: true,
          suiteId: this.$route.query.suitId,
        };

        let temp = {};
        this.suitGoodsList.map((item) => {
          temp[item.partId] = {
            partId: item.partId,
            brandName: item.brandName,
            items: [],
          };
        });
        skus.map((sku) => {
          this.suitGoodsList.map((item) => {
            item.goodsInfoList.map((item2) => {
              if (sku === item2.partGoodsInfoId) {
                temp[item.partId].items.push({
                  actSpuId: item.partGoodsId,
                  actSkuId: item2.partGoodsInfoId,
                  skuId: item2.goodsInfoId,
                  spuId: item2.goodsId,
                  goodsInfoName: item2.goodsInfoName,
                  qty: 1,
                });
              }
            });
          });
        });
        for (const key in temp) {
          subData.orderGroups[0].orders.push(temp[key]);
        }
        console.log("temp", temp);

        console.log(subData);
        this.$router.push({ name: "Settle", params: { fid: 0, subData } });
      } else {
        Toast({
          message: "请选择规格",
          position: "center",
          duration: 1000,
        });
      }
    },
    readDetail(partGoodsId, actId) {
      const name =
        this.$route.name === "HomeSuitGoods"
          ? "HomeSuitGoodsDetail"
          : "ActivityPlaceGoodsDetail";
      this.$router.push({ name, params: { id: partGoodsId, aid: actId } });
    },
  },
  computed: {
    actPriceTotal() {
      let a = 0;
      this.suitGoodsList.map((item) => (a += item.actPrice));
      return a.toFixed(2);
    },
    suitPriceTotal() {
      let b = 0;
      this.suitGoodsList.map((item) => (b += item.reducePrice));
      return (Number(this.actPriceTotal) - b).toFixed(2);
    },
  },
};
</script>

<style>
</style>